export default __webpack_public_path__ + "64ca6d5e3488cc9532c56bbcad5d20ad.png";